import { EcoaContent } from "@components/common/EconContent";
import React from "react";
import { Footer } from "@layouts/Footer";
import { usePreScreeningSiteContext } from "@layouts/home/PreScreeningSiteContext";
import { PreScreeningNoticeSpec } from "maven-lib/dist/consts/edc/crf";
import { StudyCaptureData } from "maven-lib/dist/dto/entity/studyCapture";
import { ecoaCaptureApi } from "maven-lib/dist/states/apis/ecoaCapture";
import { hasOwnProperty } from "maven-lib/dist/utils/misc";
import { HbButton } from "@maven-surface/components/base/HbButton";
import { HbParagraph } from "@maven-surface/components/base/HbParagraph";
import { HbRequestButton } from "@maven-surface/components/base/HbRequestButton";
import { useRoute } from "@maven-surface/hooks/useRoute";
import { ECOA_CAPTURE_CODE } from "@maven-msg/code/ecoaCapture";
import { COMMON_LANG } from "@maven-msg/lang/common";
import { ECOA_CAPTURE_LANG } from "@maven-msg/lang/ecoaCapture";
import { MvnMessage } from "@maven-msg/lib/Message";

interface PreScreeningResultNoticeContentProps {
  content: Array<PreScreeningNoticeSpec>;
}

interface PreScreeningDoneProps {
  studyId: bigint;
  notice: {
    pass: Array<PreScreeningNoticeSpec>;
    fail: Array<PreScreeningNoticeSpec>;
  };
}

interface PreScreeningFailedProps extends PreScreeningResultNoticeContentProps {
  studyId: bigint;
  siteId?: bigint;
  getPreScreeningParams: () => {
    encryptedPayload: string;
    captures: Array<StudyCaptureData>;
  };
}

function PreScreeningResultNoticeContent(props: PreScreeningResultNoticeContentProps) {
  return (
    <EcoaContent>
      {props.content.map((text, index) => (
        <HbParagraph
          key={index}
          spacing={1}
          bold={text && hasOwnProperty(text, "bold") ? text.bold : false}
          align={text && hasOwnProperty(text, "align") ? text.align : "LEFT"}
          text={text && hasOwnProperty(text, "text") ? text.text : text}
          size={text && hasOwnProperty(text, "size") ? text.size : "X-LARGE"}
          color={((color) => (color === "RED" ? "DANGER" : color === "GRAY" ? "GRAY" : color === "BLUE" ? "PRIMARY" : undefined))(
            text && hasOwnProperty(text, "color") ? text.color : "BLACK"
          )}
        />
      ))}
    </EcoaContent>
  );
}

export function PreScreeningDone(props: PreScreeningDoneProps) {
  const {
    studyId,
    notice: { pass, fail },
  } = props;
  const { query, replacePath } = useRoute();
  const { setSelectedSite } = usePreScreeningSiteContext();

  return (
    <>
      <PreScreeningResultNoticeContent content={query.pass === "false" ? fail : pass} />
      <Footer>
        <HbButton
          onClick={() => {
            setSelectedSite(null);
            replacePath(`/${studyId}/recruit`);
          }}
          text={MvnMessage(COMMON_LANG.CONFIRM_ALTER)}
        />
      </Footer>
    </>
  );
}

export function PreScreeningFailed(props: PreScreeningFailedProps) {
  const { studyId, siteId, content, getPreScreeningParams } = props;
  const { setSelectedSite } = usePreScreeningSiteContext();

  const { replacePath } = useRoute();
  return (
    <>
      <PreScreeningResultNoticeContent content={content} />
      <Footer>
        <HbRequestButton
          api={{
            ...ecoaCaptureApi.captureEcoaPrescreeningCaptures(studyId),
            data: siteId ? { ...(getPreScreeningParams() as any), siteId } : getPreScreeningParams(),
          }}
          delegate={{
            success: () => {
              setSelectedSite(null);
              replacePath(`/${studyId}/recruit`);
            },
            error: (error) =>
              MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_CAPTURE_FAIL, { message: error }, [ECOA_CAPTURE_CODE.ECOA_CAPTURE_DATA_MISSING]),
          }}
          text={MvnMessage(COMMON_LANG.CONFIRM_ALTER)}
        />
      </Footer>
    </>
  );
}
